<template>
  <generic-container
    class="ui container"
    :title="$t('section settings')"
    icon="book"
    :show_plus="false"
    :header_buttons="header_buttons"
  >
    <div class="description">
      <div class="ui form">
        <h4 class="ui dividing header">{{ $t("basic info") }}</h4>
        <div class="four fields">
          <div class="field">
            <label for="">{{ $t("name") }}</label>
            <input type="text" v-model="section.name" />
          </div>
          <div class="field">
            <label for="">{{ $t("professor") }}</label>
            <!-- <input type="text" v-model="section.professor" /> -->
            <div class="ui blue search" ref="professor_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  :placeholder="$t('search professor')"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("branch") }}</label>
            <div class="ui search selection dropdown" ref="branch_dropdown">
              <input type="hidden" name="branch" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("studying time") }}</label>
            <div class="ui search selection dropdown" ref="studying_dropdown">
              <input type="hidden" name="studying_time" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
        </div>
        <h4 class="ui dividing header">{{ $t("complementary info") }}</h4>

        <!-- <div class="three fields"> -->

        <!-- <div class="field">
            <label for="">{{ $t("study time") }}</label>
            <div class="ui selection dropdown" ref="studying_time_dropdown">
              <input type="hidden" name="studying_time" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("schedule") }}</label>
            <div class="ui selection dropdown" ref="schedule_dropdown">
              <input type="hidden" name="schedule" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div> -->
        <!-- </div> -->
        <div class="ui three column grid">
          <div class="row">
            <div
              class="column"
              v-for="(attribute, aidx) in section.attributes"
              :key="aidx"
              style="padding: 0 0.5em"
            >
              <div class="field">
                <label for="">{{ attribute.name }}</label>
                <input type="text" v-model="section.attributes[aidx].value" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <h4 class="ui dividing header">
        <i class="users icon"></i> {{ $t("students") }} ({{
          section.students.length
        }})
      </h4>
      <table class="ui very compact stiped celled table">
        <thead>
          <tr>
            <th>{{ $t("student id card") }}</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("career") }}</th>
            <th>{{ $t("branch") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in section.students" :key="idx">
            <td>{{ item.std_student.student_id_card }}</td>
            <td>{{ item.std_student.name }}</td>
            <td>{{ item.std_career.name }}</td>
            <td>{{ item.std_branch.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </generic-container>
</template>

<script>
import { init_search, local_api, error_toast } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import { success_toast } from "@/utils";

export default {
  name: "CourseAssignationDistributionSection",
  props: {
    section: Object,
    season: Object,
    course: Object,
    branches: Array,
    studying_times: Array,
  },
  components: { GenericContainer },
  data() {
    return {
      header_buttons: [
        {
          icon: "red trash",
          tooltip: this.$t("delete"),
          click: this.remove_section,
        },
        {
          icon: "blue save",
          tooltip: this.$t("save"),
          click: this.save,
        },
        {
          icon: "refresh",
          tooltip: this.$t("update attributes"),
          click: this.update_attributes,
        },
      ],
    };
  },
  methods: {
    remove_section() {
      this.$emit("remove");
    },
    save() {
      let vm = this;
      let data = {
        uuid: vm.section.uuid,
        name: vm.section.name,
        branch: vm.section.branch_id,
        studying_time: vm.section.studying_time_id,
        professor: vm.section.professor,
        students: vm.section.students,
        attributes: vm.section.attributes,
        course: vm.course.course_id,
        season: vm.season.season_id,
      };

      if (
        data.name &&
        data.professor &&
        data.students &&
        data.students.length > 0
      ) {
        local_api(vm, "post", "/course/assignation/do-save-section", data)
          .then(() => {
            success_toast(vm.$t("section saved"));
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(
          vm.$t(
            "check section name, professor and students, all are required to save section",
          ),
        );
      }
    },
    update_attributes() {
      console.log("update_attributes");
    },
  },
  mounted() {
    let vm = this;

    let onSearchResponse = (data) => {
      let rslt = [];
      data.map((r) => {
        rslt.push({
          title: r.usr_user.name,
          description: r.usr_user.username,
          user: r,
        });
      });
      return { results: rslt };
    };
    let onSearchSelect = (data) => {
      vm.section.professor = data.user.professor_id;
    };

    init_search(
      vm,
      vm.$refs.professor_search,
      "search professor",
      onSearchResponse,
      onSearchSelect,
    );

    /**
     * Init branch dropdown
     */
    let vls = vm.branches.map((b) => {
      return { name: b.name, value: b.branch_id };
    });
    window
      .jQuery(vm.$refs.branch_dropdown)
      .dropdown("setup menu", { values: vls })
      .dropdown({
        onChange(value) {
          vm.section.branch_id = value;
        },
      });

    /**
     * Init studying time dropdown
     */
    let vlsstd = vm.studying_times.map((b) => {
      return { name: b.name, value: b.studying_time_id };
    });
    window
      .jQuery(vm.$refs.studying_dropdown)
      .dropdown("setup menu", { values: vlsstd })
      .dropdown({
        onChange(value) {
          vm.section.studying_time_id = value;
        },
      });

    setTimeout(() => {
      /**
       * Set section data
       */
      if (vm.section.branch) {
        window
          .jQuery(vm.$refs.branch_dropdown)
          .dropdown("set selected", vm.section.branch);
      }

      if (vm.section.studying_time) {
        window
          .jQuery(vm.$refs.studying_dropdown)
          .dropdown("set selected", vm.section.studying_time);
      }
    }, 200);
  },
};
</script>
